var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54.75 0h402.5v512h-402.5z",
    fill: "#fef1f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0h201.25v512h-201.25z",
    fill: "#ebdfd9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.743 172.707-21.213-21.213-22.732 22.732-24.031-24.031c16.939-6.583 28.983-23.051 28.983-42.289 0-25.012-20.349-45.361-45.361-45.361h-52.316v136.701h30v-45.319l41.512 41.512-22.732 22.732 21.213 21.213 22.732-22.732 22.732 22.732 21.213-21.213-22.732-22.732zm-106.67-80.162h22.316c8.47 0 15.361 6.891 15.361 15.361s-6.891 15.361-15.361 15.361h-22.316z",
    fill: "#39689e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.083 277h30v30h-30z",
    fill: "#ff4945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.75 277h200v30h-200z",
    fill: "#79d5fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.5 213.778h101.25v30h-101.25z",
    fill: "#4bbbf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.083 340.222h30v30h-30z",
    fill: "#ff4945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.75 340.22h200v30h-200z",
    fill: "#79d5fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.085 404.065h30v30h-30z",
    fill: "#ff4945",
    transform: "matrix(1 -.005 .005 1 -2.222 .744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.83 432.75-131.83.7-68.17.36-.16-30 68.33-.36 131.67-.7z",
    fill: "#79d5fa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4bbbf0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 277h131.75v30h-131.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 340.22h131.75v30h-131.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.83 432.75-131.83.7v-30l131.67-.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/prescription.379de3a8.svg";
export { ForwardRef as ReactComponent };